module.exports = __webpack_public_path__ + "static/texture-57c62366822f3831a60a7fe54b356eee.jpg";